const dummyData = [
  {
    _id: 0,
    email: `hichiefmikey@gmail.com`,
    password: `hotdog`,
    joined: `4/20/2010`,
    description: {
      firstName: `Chief`,
      lastName: `Mikey`,
      pic: `https://avatars.githubusercontent.com/u/22719398?v=4`,
      mood: `cloudy`,
      moodEmoji: `;)`,
      status: `:-)`,
      gender: `Male`,
      age: `30`,
      city: `Arvada`,
      state: `COLORADO`,
      country: `United States`,
      login: `4/20/2020`,
    },
    links: [
      {
        name: `Spotify`,
        url: `https://open.spotify.com/artist/3akPw7PH5dI7cxJauJdqki?si=3f-49lYGToG4kQgLwRAdxg`,
      },
      {
        name: `Apple Music`,
        url: `https://music.apple.com/us/artist/chief-mikey/1106127010`,
      },
      { name: `YouTube`, url: `https://youtube.com/user/chiefmky` },
      { name: `Bandcamp`, url: `https://hichiefmikey.bandcamp.com/` },
    ],
    urlAddress: `/chiefmikey`,
    interests: {
      general: `Coopers has calamari`,
      music: `M83, Clams Casino, samashi, eevee, postu, Jadu Heart, heliflopper, Jay Som, Gabriel Garzón-Montano, Real Estate, Toro y Moi, dvsn, Frank Ocean, A$AP Rocky, ScHoolboy Q, Amir Obe, Kudasaibeats, Sun Glitters, Giraffage, Majid Jordan`,
      movies: `Hans Zimmer, Danny Elfman, Quincy Jones`,
      television: `I'd rather youtube`,
      books: `Hard to hear books`,
      heroes: `Logic + Reason`,
    },
    details: {
      status: `♩ ♪ ♫ ♬`,
      hereFor: `Chunes`,
      hometown: `Oakland, CA`,
      zodiacSign: `☯`,
      smokeDrink: `/ Party`,
      occupation: `Artist`,
    },
    headline: `in the chill zone`,
    contentPosts: [
      {
        _id: 6,
        title: `what else`,
        text: `were not friends so dont text my parents anymore`,
      },
      {
        _id: 5,
        title: `just because`,
        text: `i hate you.`,
      },
      {
        _id: 4,
        title: `i could use some help`,
        text: `just kidding i hate you`,
      },
      {
        _id: 3,
        title: `further discussion`,
        text: `dont forget i know everything`,
      },
      {
        _id: 2,
        title: `what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what`,
        text: `ah fuhck, i believe you have done me wrong.`,
      },
      {
        _id: 1,
        title: `excellent`,
        text: `i will shoot forth the lasers from my eyeballs`,
      },
      {
        _id: 0,
        title: `ok guys`,
        text: `stop it`,
      },
    ],
    blurbs: {
      aboutMe: `I'd rather be at home, stoned and alone.`,
      whoIdLikeToMeet: `your mom`,
    },
    friends: [
      [9, 3],
      [8, 0],
      [7, 2],
      [6, 0],
      [5, 2],
      [4, 0],
      [3, 0],
      [2, 2],
      [1, 1],
      [0, 3],
    ],
    comments: [
      [2, 0, `Sep 21 2008 5:26P`, `fahrk`],
      [1, 1, `Oct 1 2007 1:46A`, `stop it now please ok`],
      [0, 1, `Nov 3 2005 6:56P`, `slam dunk it`],
    ],
  },
  {
    _id: 1,
    email: `cliff.dawg@gmail.com`,
    password: `dipshit`,
    joined: `4/20/2011`,
    description: {
      firstName: `clifford`,
      lastName: ``,
      pic: `https://static01.nyt.com/images/2018/05/17/arts/television/17clifford-item/17clifford-item-articleLarge.jpg?quality=75&auto=webp&disable=upscale`,
      mood: `woof`,
      moodEmoji: `:P`,
      status: `im red`,
      gender: `Male`,
      age: `12`,
      city: `Seattle`,
      state: `WASHINGTON`,
      country: `United States`,
      login: `5/23/2021`,
    },
    links: [
      { name: `GitHub`, url: `https://github.com/chiefmikey` },
      { name: `LinkedIn`, url: `https://linkedin.com/in/miklwolfe` },
      { name: `GitHub`, url: `https://github.com/chiefmikey` },
      { name: `Instagram`, url: `https://instagram.com/chief.mikey` },
    ],
    urlAddress: `/clifford`,
    interests: {
      general: `being big and being a dog`,
      music: `music is great`,
      movies: `101 dalmatians`,
      television: `tv is cool`,
      books: `wow books`,
      heroes: `other big dogs`,
    },
    details: {
      status: `here for a good time`,
      hereFor: `status is chillin`,
      hometown: `seattle`,
      zodiacSign: `doggy`,
      smokeDrink: `both`,
      occupation: `being a big dog`,
    },
    headline: `woof woof woof woof`,
    contentPosts: [
      {
        _id: 2,
        title: `wow thats a big hot dog`,
        text: `its of the casper variety i suppose, but one could argue that. im not sure if the absolute quantity of remaining sausage is enough for your mom to fit in her mouth. so dont forget that and keep a visual of it in your mind when you go to sleep at night. if this is long enough i can stop typing and just see if this example fits in the stupid column or not but whatever its just part of what i do and typing is a hoot.`,
      },
      {
        _id: 1,
        title: `crazy night`,
        text: `chess board am i right`,
      },
      {
        _id: 0,
        title: `sup`,
        text: `stop it`,
      },
    ],
    blurbs: {
      aboutMe: `im clifford, dumbass`,
      whoIdLikeToMeet: `charlie from charlie brown`,
    },
    friends: [
      [0, 3],
      [1, 2],
      [2, 1],
      [3, 2],
      [4, 1],
      [5, 0],
    ],
    comments: [
      [2, 0, `Sep 21 2008 5:26P`, `fahrk`],
      [1, 0, `Oct 1 2007 1:46A`, `stop it now please ok`],
    ],
  },
  {
    _id: 2,
    email: `repeatrepeatrepeatrepeat@gmail.com`,
    password: `repeatdipshit`,
    joined: `2/10/2000`,
    description: {
      firstName: `repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat`,
      lastName: `repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat`,
      pic: `https://images.csmonitor.com/csmarchives/2011/10/1024-LMUPPETS-VERT-KERMIT-MUPPETS-CULTURE-MOVIE-FILM.jpg?alias=standard_900x600nc`,
      mood: `repeat`,
      moodEmoji: `:(`,
      status: `repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat`,
      gender: `Male`,
      age: `999`,
      city: `Repeat`,
      state: `REPEAT`,
      country: `Repeat`,
      login: `6/23/2021`,
    },
    links: [
      { name: `GitHub`, url: `https://github.com/chiefmikey` },
      { name: `LinkedIn`, url: `https://linkedin.com/in/miklwolfe` },
      { name: `GitHub`, url: `https://github.com/chiefmikey` },
      { name: `Instagram`, url: `https://instagram.com/chief.mikey` },
    ],
    urlAddress: `/repeatrepeatrepeatrepeatrepeatrepeatrepeatrepeatrepeatrepeatrepeatrepeatrepeatrepeatrepeatrepeatrepeatrepeatrepeatrepeatrepeatrepeatrepeatrepeatrepeatrepeatrepeatrepeatrepeatrepeatrepeatrepeatrepeatrepeatrepeatrepeatrepeatrepeatrepeatrepeatrepeatrepeatrepeatrepeatrepeatrepeatrepeatrepeatrepeatrepeatrepeatrepeatrepeatrepeatrepeatrepeatrepeatrepeat`,
    interests: {
      general: `repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat`,
      music: `repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat`,
      movies: `repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat`,
      television: `repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat`,
      books: `repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat`,
      heroes: `repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat`,
    },
    details: {
      status: `repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat`,
      hereFor: `repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat`,
      hometown: `repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat`,
      zodiacSign: `repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat`,
      smokeDrink: `repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat`,
      occupation: `repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat`,
    },
    headline: `repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat`,
    contentPosts: [
      {
        _id: 2,
        title: `repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat`,
        text: `repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat`,
      },
      {
        _id: 1,
        title: `repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat`,
        text: `repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat`,
      },
      {
        _id: 0,
        title: `repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat`,
        text: `repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat`,
      },
    ],
    blurbs: {
      aboutMe: `repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat`,
      whoIdLikeToMeet: `repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat`,
    },
    friends: [
      [0, 3],
      [1, 0],
      [2, 1],
      [3, 0],
      [4, 1],
      [5, 0],
    ],
    comments: [
      [
        2,
        1,
        `Sep 21 2008 5:26P`,
        `repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat`,
      ],
      [
        1,
        0,
        `Oct 1 2007 1:46A`,
        `repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat repeat`,
      ],
    ],
  },
  {
    _id: 3,
    email: `wolfemikl@gmail.com`,
    password: `dipshit`,
    joined: `05/14/2021`,
    description: {
      firstName: `Mikl`,
      lastName: `Wolfe`,
      pic: `https://media-exp1.licdn.com/dms/image/C5603AQGide0jijb8rQ/profile-displayphoto-shrink_800_800/0/1626735684328?e=1639008000&v=beta&t=-5bjctIbXCNMSXh9a3_1giKezB9QyJKj48oH-tasw8k`,
      mood: `chill`,
      moodEmoji: `:)`,
      status: `Tom 2.0`,
      gender: `Male`,
      age: `30`,
      city: `Arvada`,
      state: `COLORADO`,
      country: `United States`,
      login: `7/28/2021`,
    },
    links: [
      { name: `LinkedIn`, url: `https://linkedin.com/in/miklwolfe` },
      { name: `GitHub`, url: `https://github.com/chiefmikey` },
      { name: `Instagram`, url: `https://instagram.com/chief.mikey` },
    ],
    urlAddress: `/wolfe`,
    interests: {
      general: `Expressing myself artistically`,
      music: `Lofi & dark techno`,
      movies: `The Labyrinth`,
      television: `Anything with Gordon Ramsey`,
      books: `Do docs count as books?`,
      heroes: `My wife`,
    },
    details: {
      status: `Available for hire`,
      hereFor: `Networking`,
      hometown: `Murphys, CA`,
      zodiacSign: `Capricorn`,
      smokeDrink: `Just need coffee`,
      occupation: `Full stack software engineer`,
    },
    headline: `busy rebuilding Myspace from 2007`,
    contentPosts: [
      {
        _id: 0,
        title: `Mikl Wolfe Resume`,
        text: `
<h2><strong>MIKL WOLFE&nbsp;</strong></h2>
<p><a href="mailto:wolfe@mikl.io" target="_blank" rel="noopener">wolfe@mikl.io</a><br /><a
    href="https://github.com/chiefmikey" target="_blank" rel="noopener">github.com/chiefmikey</a> | <a
    href="https://www.linkedin.com/in/miklwolfe/" target="_blank" rel="noopener">linkedin.com/in/miklwolfe</a></p>
<p>
  <h4 style="font-weight: 100; height: 0">TECHNICAL SKILLS</h4><br /><strong>Technologies </strong>| JS, Node, React,
  Vue, Express, Koa, Axios, Webpack, Babel, PostgreSQL, MongoDB<br /><strong>Resources </strong>| AWS, Docker,
  Loader.io, CraftCMS, Postman, Heroku, Git, Notion, Sonar, Airbnb Style Guide
</p>
<p>
  <h4 style="font-weight: 100; height: 0">EXPERIENCE</h4><br /><strong>Chia Decentral</strong> | <em>Full Stack
    Engineer</em> | 2021 | <a href="https://chiadecentral.com" target="_blank" rel="noopener">Website</a>
  <ul>
    <li>Multiplied throughput capacity 10x with a reverse proxy implementation using Varnish</li>
    <li>Prioritized efficiency by customizing Alpine- based Docker images with minimal installations</li>
    <li>Inspired growth by mapping AWS scaling to 10,000 requests per second with a 12ms average</li>
  </ul>
  <p><strong>EHIR</strong> | <em>Creative Producer</em> | 2019&ndash;2021 | <a href="https://ehir.com" target="_blank"
      rel="noopener">Website</a></p>
  <ul>
    <li>Strengthened visual representation by improving the overall quality of branded assets</li>
    <li>Elevated user experience with refined web design and enhanced client optimization</li>
  </ul>
  <p><strong>The Simon Collective</strong> | <em>Creative Producer</em> | 2017&ndash;2019 | <a
      href="https://thesimoncollective.com" target="_blank" rel="noopener">Website</a></p>
  <ul>
    <li>Established brand development consistency with a reimagined logo and asset guidelines</li>
    <li>Supported communication and drove business exposure by creating a strong web presence</li>
  </ul>
  <p><strong>Rodan + Fields</strong> | <em>Video Producer &amp; Animator</em> | 2012&ndash;2015 | <a
      href="https://www.youtube.com/watch?v=Wb0jsR_NAsw" target="_blank" rel="noopener">Video</a></p>
  <ul>
    <li>Generated value by producing high quality deliverables both autonomously and as a team</li>
    <li>Ensured communication transparency by collaborating daily with top level executives</li>
  </ul>
</p>
<p>
  <h4 style="font-weight: 100; height: 0">SOFTWARE ENGINEERING PROJECTS</h4></br><strong>The Myspace</strong> | <em>Full
    Stack Engineer</em> | React, Express, MongoDB | <a href="https://github.com/chiefmikey/the-myspace" target="_blank"
    rel="noopener">GitHub</a><br /><span style="color: #666666;">Full stack recreation of a popular social networking
    platform</span>
  <ul>
    <li>Engaged users by reducing time to fFirst cContentful pPaint with progressively rendered images</li>
    <li>Expanded availability with single page URL navigation that creatively leverages React Router</li>
    <li>Influenced client accessibility with dynamic string lengths clamped using LinesEllipsis</li>
  </ul>
  <p><strong>Name Generator</strong> | <em>Full Stack Engineer</em> | Vue, Koa, Cassandra | <a
      href="https://github.com/chiefmikey/name-generator" target="_blank" rel="noopener">GitHub</a><br /><span
      style="color: #666666;">Full stack text generator with dynamic results built from public data sources</span></p>
  <ul>
    <li>Introduced collaborative fluidity with separation of concerns using Vue Single File Components</li>
    <li>Refined data availability by shaping public information received from a variety of external APIs</li>
    <li>Minimized response times by serving frequently- used data from a persistent NoSQL database</li>
  </ul>
  <p><strong>Catwalk</strong> | <em>Front End Engineer</em> | Babel, Webpack, CircleCI&nbsp;| <a
      href="https://github.com/chiefmikey/catwalk" target="_blank" rel="noopener">GitHub</a><br /><span
      style="color: #666666;">Front end design and interactive functionality for a product platform</span>
    <ul>
      <li>Increased performance with reduced client workload by shaping data on the Express server</li>
      <li>Improved platform accessibility with a flexible and responsive React front end utilizing Flexbox&nbsp;</li>
      <li>Enhanced user experience and engagement by subtly detailing attractive CSS animations</li>
    </ul>
  </p>
  <p>
    <h4 style="font-weight: 100; height: 0">EDUCATION</h4></br><strong>Hack Reactor Galvanize</strong> | <em>Advanced
      Software Engineering Immersive Program</em> | 2021</br><strong>SAE Expression College</strong> |<em> BAS, Motion
      Graphic Design</em>&nbsp;| 2012<br /><strong>Berklee College of Music</strong> | <em>Music Production</em>&nbsp;|
    2008
  </p>`,
      },
    ],
    blurbs: {
      aboutMe:
        'I have always been a driven creator, constantly developing unique solutions to my challenges. This passion amplifies my abilities as a software engineer and enables my work to provide me with fulfillment. Regardless of where I`m focused, I find all paths throughout the full stack to be exciting and rewarding.',
      whoIdLikeToMeet: `Other like-minded individuals who solve problems using logic and creativity.`,
    },
    friends: [
      [0, 0],
      [1, 5],
      [2, 6],
      [3, 7],
      [4, 4],
      [5, 2],
      [6, 1],
      [7, 8],
    ],
    comments: [
      [2, 2, `Sep 21 2008 5:26P`, `hey buddy`],
      [1, 1, `Oct 1 2007 1:46A`, `you there`],
    ],
  },
  {
    _id: 4,
    email: `mikl@lovefidelity.com`,
    password: `hotdog`,
    joined: `4/20/2010`,
    description: {
      firstName: `Skeletor`,
      lastName: ``,
      pic: `https://www.writeups.org/wp-content/uploads/Skeletor-Masters-Universe-cartoon-h5-frustration.jpg`,
      mood: `confused`,
      moodEmoji: `:S`,
      status: `dm me`,
      gender: `Demon`,
      age: `21`,
      city: `Snake Mountain`,
      state: `DARK HEMISPHERE`,
      country: `Eternia`,
      login: `4/20/2020`,
    },
    links: [
      { name: `GitHub`, url: `https://github.com/chiefmikey` },
      { name: `LinkedIn`, url: `https://linkedin.com/in/miklwolfe` },
      { name: `GitHub`, url: `https://github.com/chiefmikey` },
      { name: `Instagram`, url: `https://instagram.com/chief.mikey` },
    ],
    urlAddress: `/skellybelly`,
    interests: {
      general: `internet, doggies, etc.`,
      music: `rock n roll asian fusion`,
      movies: `muppets treasure island`,
      television: `cheers`,
      books: `what is books`,
      heroes: `the rock aka dawayan johnston`,
    },
    details: {
      status: `swexy`,
      hereFor: `lasagna`,
      hometown: `hawkins, in`,
      zodiacSign: `i guess so`,
      smokeDrink: `69`,
      occupation: `keepin it breezy`,
    },
    headline: `ready to party rock`,
    contentPosts: [
      {
        _id: 6,
        title: `what else`,
        text: `were not friends so dont text my parents anymore`,
      },
      {
        _id: 5,
        title: `just because`,
        text: `i hate you.`,
      },
      {
        _id: 4,
        title: `i could use some help`,
        text: `just kidding i hate you`,
      },
      {
        _id: 3,
        title: `further discussion`,
        text: `dont forget i know everything`,
      },
      {
        _id: 2,
        title: `what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what`,
        text: `ah fuhck, i believe you have done me wrong.`,
      },
      {
        _id: 1,
        title: `excellent`,
        text: `i will shoot forth the lasers from my eyeballs`,
      },
      {
        _id: 0,
        title: `ok guys`,
        text: `stop it`,
      },
    ],
    blurbs: {
      aboutMe: `a blue-skinned humanoid who wears a purple hood over his bare-bone skull.`,
      whoIdLikeToMeet: `your mom`,
    },
    friends: [
      [9, 3],
      [8, 0],
      [7, 2],
      [6, 0],
      [5, 2],
      [4, 0],
      [3, 0],
      [2, 2],
      [1, 1],
      [0, 3],
    ],
    comments: [
      [2, 0, `Sep 21 2008 5:26P`, `fahrk`],
      [1, 1, `Oct 1 2007 1:46A`, `stop it now please ok`],
      [0, 1, `Nov 3 2005 6:56P`, `slam dunk it`],
    ],
  },
  {
    _id: 5,
    email: `itsacloudynight@gmail.com`,
    password: `hotdog`,
    joined: `1/1/2020`,
    description: {
      firstName: `Cloudy`,
      lastName: `Nights`,
      pic: `https://i.scdn.co/image/ab6761610000e5ebcb64c122b5ed111b6ac4b8e1`,
      mood: `confused`,
      moodEmoji: `:S`,
      status: `dm me`,
      gender: `Demon`,
      age: `21`,
      city: `Snake Mountain`,
      state: `DARK HEMISPHERE`,
      country: `Eternia`,
      login: `4/20/2020`,
    },
    links: [
      { name: `Spotify`, url: `https://github.com/chiefmikey` },
      { name: `Apple Music`, url: `https://linkedin.com/in/miklwolfe` },
      { name: `YouTube`, url: `https://github.com/chiefmikey` },
      { name: `Bandcamp`, url: `https://instagram.com/chief.mikey` },
    ],
    urlAddress: `/cloudy`,
    interests: {
      general: `internet, doggies, etc.`,
      music: `rock n roll asian fusion`,
      movies: `muppets treasure island`,
      television: `cheers`,
      books: `what is books`,
      heroes: `the rock aka dawayan johnston`,
    },
    details: {
      status: `swexy`,
      hereFor: `lasagna`,
      hometown: `hawkins, in`,
      zodiacSign: `i guess so`,
      smokeDrink: `69`,
      occupation: `keepin it breezy`,
    },
    headline: `ready to party rock`,
    contentPosts: [
      {
        _id: 6,
        title: `what else`,
        text: `were not friends so dont text my parents anymore`,
      },
      {
        _id: 5,
        title: `just because`,
        text: `i hate you.`,
      },
      {
        _id: 4,
        title: `i could use some help`,
        text: `just kidding i hate you`,
      },
      {
        _id: 3,
        title: `further discussion`,
        text: `dont forget i know everything`,
      },
      {
        _id: 2,
        title: `what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what`,
        text: `ah fuhck, i believe you have done me wrong.`,
      },
      {
        _id: 1,
        title: `excellent`,
        text: `i will shoot forth the lasers from my eyeballs`,
      },
      {
        _id: 0,
        title: `ok guys`,
        text: `stop it`,
      },
    ],
    blurbs: {
      aboutMe: `a blue-skinned humanoid who wears a purple hood over his bare-bone skull.`,
      whoIdLikeToMeet: `your mom`,
    },
    friends: [
      [9, 3],
      [8, 0],
      [7, 2],
      [6, 0],
      [5, 2],
      [4, 0],
      [3, 0],
      [2, 2],
      [1, 1],
      [0, 3],
    ],
    comments: [
      [2, 0, `Sep 21 2008 5:26P`, `fahrk`],
      [1, 1, `Oct 1 2007 1:46A`, `stop it now please ok`],
      [0, 1, `Nov 3 2005 6:56P`, `slam dunk it`],
    ],
  },
  {
    _id: 6,
    email: `skellyripa@gmail.com`,
    password: `hotdog`,
    joined: `4/20/2010`,
    description: {
      firstName: `Name Generator`,
      lastName: ``,
      pic: `https://i.insider.com/6040b55fb46d720018b04c88?width=700`,
      mood: `confused`,
      moodEmoji: `:S`,
      status: `dm me`,
      gender: `Demon`,
      age: `21`,
      city: `Snake Mountain`,
      state: `DARK HEMISPHERE`,
      country: `Eternia`,
      login: `4/20/2020`,
    },
    links: [
      { name: `GitHub`, url: `https://github.com/chiefmikey` },
      { name: `LinkedIn`, url: `https://linkedin.com/in/miklwolfe` },
      { name: `GitHub`, url: `https://github.com/chiefmikey` },
      { name: `Instagram`, url: `https://instagram.com/chief.mikey` },
    ],
    urlAddress: `/name-generator`,
    interests: {
      general: `internet, doggies, etc.`,
      music: `rock n roll asian fusion`,
      movies: `muppets treasure island`,
      television: `cheers`,
      books: `what is books`,
      heroes: `the rock aka dawayan johnston`,
    },
    details: {
      status: `swexy`,
      hereFor: `lasagna`,
      hometown: `hawkins, in`,
      zodiacSign: `i guess so`,
      smokeDrink: `69`,
      occupation: `keepin it breezy`,
    },
    headline: `ready to party rock`,
    contentPosts: [
      {
        _id: 6,
        title: `what else`,
        text: `were not friends so dont text my parents anymore`,
      },
      {
        _id: 5,
        title: `just because`,
        text: `i hate you.`,
      },
      {
        _id: 4,
        title: `i could use some help`,
        text: `just kidding i hate you`,
      },
      {
        _id: 3,
        title: `further discussion`,
        text: `dont forget i know everything`,
      },
      {
        _id: 2,
        title: `what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what`,
        text: `ah fuhck, i believe you have done me wrong.`,
      },
      {
        _id: 1,
        title: `excellent`,
        text: `i will shoot forth the lasers from my eyeballs`,
      },
      {
        _id: 0,
        title: `ok guys`,
        text: `stop it`,
      },
    ],
    blurbs: {
      aboutMe: `a blue-skinned humanoid who wears a purple hood over his bare-bone skull.`,
      whoIdLikeToMeet: `your mom`,
    },
    friends: [
      [9, 3],
      [8, 0],
      [7, 2],
      [6, 0],
      [5, 2],
      [4, 0],
      [3, 0],
      [2, 2],
      [1, 1],
      [0, 3],
    ],
    comments: [
      [2, 0, `Sep 21 2008 5:26P`, `fahrk`],
      [1, 1, `Oct 1 2007 1:46A`, `stop it now please ok`],
      [0, 1, `Nov 3 2005 6:56P`, `slam dunk it`],
    ],
  },
  {
    _id: 7,
    email: `mikl@lovefidelity.com`,
    password: `hotdog`,
    joined: `4/20/2010`,
    description: {
      firstName: `Cloudyman`,
      lastName: ``,
      pic: `/img/cloudymansocial.png`,
      mood: `confused`,
      moodEmoji: `:S`,
      status: `dm me`,
      gender: `Demon`,
      age: `21`,
      city: `Snake Mountain`,
      state: `DARK HEMISPHERE`,
      country: `Eternia`,
      login: `4/20/2020`,
    },
    links: [
      { name: `GitHub`, url: `https://github.com/chiefmikey` },
      { name: `LinkedIn`, url: `https://linkedin.com/in/miklwolfe` },
      { name: `GitHub`, url: `https://github.com/chiefmikey` },
      { name: `Instagram`, url: `https://instagram.com/chief.mikey` },
    ],
    urlAddress: `/cloudyman`,
    interests: {
      general: `internet, doggies, etc.`,
      music: `rock n roll asian fusion`,
      movies: `muppets treasure island`,
      television: `cheers`,
      books: `what is books`,
      heroes: `the rock aka dawayan johnston`,
    },
    details: {
      status: `swexy`,
      hereFor: `lasagna`,
      hometown: `hawkins, in`,
      zodiacSign: `i guess so`,
      smokeDrink: `69`,
      occupation: `keepin it breezy`,
    },
    headline: `ready to party rock`,
    contentPosts: [
      {
        _id: 6,
        title: `what else`,
        text: `were not friends so dont text my parents anymore`,
      },
      {
        _id: 5,
        title: `just because`,
        text: `i hate you.`,
      },
      {
        _id: 4,
        title: `i could use some help`,
        text: `just kidding i hate you`,
      },
      {
        _id: 3,
        title: `further discussion`,
        text: `dont forget i know everything`,
      },
      {
        _id: 2,
        title: `what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what`,
        text: `ah fuhck, i believe you have done me wrong.`,
      },
      {
        _id: 1,
        title: `excellent`,
        text: `i will shoot forth the lasers from my eyeballs`,
      },
      {
        _id: 0,
        title: `ok guys`,
        text: `stop it`,
      },
    ],
    blurbs: {
      aboutMe: `a blue-skinned humanoid who wears a purple hood over his bare-bone skull.`,
      whoIdLikeToMeet: `your mom`,
    },
    friends: [
      [9, 3],
      [8, 0],
      [7, 2],
      [6, 0],
      [5, 2],
      [4, 0],
      [3, 0],
      [2, 2],
      [1, 1],
      [0, 3],
    ],
    comments: [
      [2, 0, `Sep 21 2008 5:26P`, `fahrk`],
      [1, 1, `Oct 1 2007 1:46A`, `stop it now please ok`],
      [0, 1, `Nov 3 2005 6:56P`, `slam dunk it`],
    ],
  },
  {
    _id: 8,
    email: `mikl@lovefidelity.com`,
    password: `hotdog`,
    joined: `4/20/2010`,
    description: {
      firstName: `The Myspace`,
      lastName: ``,
      pic: `/img/tma.png`,
      mood: `confused`,
      moodEmoji: `:S`,
      status: `dm me`,
      gender: `Demon`,
      age: `21`,
      city: `Snake Mountain`,
      state: `DARK HEMISPHERE`,
      country: `Eternia`,
      login: `4/20/2020`,
    },
    links: [
      { name: `GitHub`, url: `https://github.com/chiefmikey` },
      { name: `LinkedIn`, url: `https://linkedin.com/in/miklwolfe` },
      { name: `GitHub`, url: `https://github.com/chiefmikey` },
      { name: `Instagram`, url: `https://instagram.com/chief.mikey` },
    ],
    urlAddress: `/themyspace`,
    interests: {
      general: `internet, doggies, etc.`,
      music: `rock n roll asian fusion`,
      movies: `muppets treasure island`,
      television: `cheers`,
      books: `what is books`,
      heroes: `the rock aka dawayan johnston`,
    },
    details: {
      status: `swexy`,
      hereFor: `lasagna`,
      hometown: `hawkins, in`,
      zodiacSign: `i guess so`,
      smokeDrink: `69`,
      occupation: `keepin it breezy`,
    },
    headline: `ready to party rock`,
    contentPosts: [
      {
        _id: 6,
        title: `what else`,
        text: `were not friends so dont text my parents anymore`,
      },
      {
        _id: 5,
        title: `just because`,
        text: `i hate you.`,
      },
      {
        _id: 4,
        title: `i could use some help`,
        text: `just kidding i hate you`,
      },
      {
        _id: 3,
        title: `further discussion`,
        text: `dont forget i know everything`,
      },
      {
        _id: 2,
        title: `what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what what`,
        text: `ah fuhck, i believe you have done me wrong.`,
      },
      {
        _id: 1,
        title: `excellent`,
        text: `i will shoot forth the lasers from my eyeballs`,
      },
      {
        _id: 0,
        title: `ok guys`,
        text: `stop it`,
      },
    ],
    blurbs: {
      aboutMe: `a blue-skinned humanoid who wears a purple hood over his bare-bone skull.`,
      whoIdLikeToMeet: `your mom`,
    },
    friends: [
      [9, 3],
      [8, 0],
      [7, 2],
      [6, 0],
      [5, 2],
      [4, 0],
      [3, 0],
      [2, 2],
      [1, 1],
      [0, 3],
    ],
    comments: [
      [2, 0, `Sep 21 2008 5:26P`, `fahrk`],
      [1, 1, `Oct 1 2007 1:46A`, `stop it now please ok`],
      [0, 1, `Nov 3 2005 6:56P`, `slam dunk it`],
    ],
  },
];

export default dummyData;
